import WidgetAjax from "./WidgetAjax";
import Config from '../config/Config';
import React, { Component } from "react";
import { Popup, Toast } from 'antd-mobile'
import { CloseCircleOutline, DownFill, RightOutline } from 'antd-mobile-icons'
import '../css/popupView.scss'
class WidgetPopup extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showPop: false,
            provinceList: [],
            provinceStr: '',
            cityList: [],
            cityStr: '',
            districtList: [],
            districtStr: [],
            choiceIndex: 1,
            showList: [],
            pua: [],
            pageList: [],
            defaultValue: [],
            timeDate: new Date().getTime()
        }
        if (this.props.onRef) {
            this.props.onRef(this);
        }
    }
    componentDidMount() {
        if (this.getSearchInfo('addressList') && this.getSearchInfo('addressList') != ',,') {
            let defaultValue = this.getSearchInfo('addressList').split(',')
            this.setState({
                defaultValue: defaultValue.length === 3 ? defaultValue : [],
                choiceIndex: defaultValue.length
            })
        }
        // if (localStorage.getItem('defaultValue') && localStorage.getItem('defaultValue') != ',,') {
        //     let list = localStorage.getItem('defaultValue')
        //     let arr = list.split(',')
        //     this.setState({
        //         defaultValue: arr,
        //         choiceIndex: arr.length
        //     })
        // }

        // 处理URL参数
        const paramsData = new URLSearchParams(window.location.search);
        const urlParams = JSON.parse(decodeURIComponent(paramsData.get('urlData') || '{}'))
        if (urlParams.urlArr && urlParams.urlName) {
            let defaultValue = [];
            let pua = [];
            // 使用URL参数的值
            defaultValue = urlParams.urlArr.split(',');
            pua = urlParams.urlName.split(',');
            
            // 更新localStorage
            localStorage.setItem('defaultValue', urlParams.urlArr);
            localStorage.setItem('ProvincialUrbanAreas', urlParams.urlName);

            this.setState({
                defaultValue: defaultValue,
                pua: pua,
                choiceIndex: defaultValue.length
            });
        } else {
            if (localStorage.getItem('defaultValue') && localStorage.getItem('defaultValue') != ',,') {
                let list = localStorage.getItem('defaultValue')
                let arr = list.split(',')
                this.setState({
                    defaultValue: arr,
                    choiceIndex: arr.length
                })
            }

            if (localStorage.getItem('ProvincialUrbanAreas') && localStorage.getItem('ProvincialUrbanAreas') != ',,') {
                let pua = localStorage.getItem('ProvincialUrbanAreas').split(',')
                this.setState({
                    pua: pua,
                    choiceIndex: 3
                })
            }
        }

        this.queryProvince("D111001")

        // if (localStorage.getItem('ProvincialUrbanAreas') && localStorage.getItem('ProvincialUrbanAreas') != ',,') {
        //     let pua = localStorage.getItem('ProvincialUrbanAreas').split(',')
        //     this.setState({
        //         pua: pua,
        //         choiceIndex: 3
        //     })
        // }


        // this.queryProvince("D330")原本就注释的
    }
    queryPartCity() {
        WidgetAjax.ajax({
            url: Config.getBasePath() + '/task/templist',
            params: {
                // dimension: obj,
                TYPE: 2,
                "UID": "S1000"
            },
            callback: (data) => {
                if (data && data.status === 0) {
                    // let list = data.results[0].values.map(res=>{return res.value})
                    // this.setState({
                    //     mapCity: data.results
                    // })
                    let list = data.results.map(res => { return res.value })

                    let arr = this.state.pageList.filter(res => { return list.includes(res.value) })
                    arr.forEach(da => {
                        let startInfo = data.results.find(res => { return res.value == da.value })
                        da.state = startInfo.state
                        da.link = startInfo?.link
                    })
                    let provinceStr = this.state.provinceStr || arr[0].value
                    if (this.state.pua && this.state.pua.length > 0) {
                        let info = arr.find(res => { return res.name === this.state.pua[0] })
                        provinceStr = info && info.value ? info.value : provinceStr
                    }

                    this.setState({
                        provinceList: arr,
                        provinceStr: provinceStr,
                        timeDate: new Date().getTime()
                    })
                    this.queryProvince('D111002', 'D111001', provinceStr)
                }
            }
        }, this);
    }
    getSearchInfo(name) {
        let info = window.location.search
        const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`);
        const r = info.substr(1).match(reg);
        if (r != null) return decodeURIComponent(r[2]); return null;
    }
    queryProvince(type, filter, code) {
        let obj = {
            code: type,
            hierarchy: type === 'D111001' ? 3 : 1,
        }
        if (filter && code) {
            obj.filter = "${" + filter + "}=" + code
        }
        WidgetAjax.ajax({
            // url: Config.getBasePath() + '/widget/dimension',
            url: Config.getBasePath() + '/customdistrict/custom_district',
            params: {
                // code:type,
                dimension: obj
                // hierarchy:"3"
            },
            callback: (data) => {
                if (data && data.status === 0) {

                    data.results[0].values.forEach(da => {
                        da.label = da.name
                    })

                    if (!filter && !code && type === 'D330') {
                        let list = data.results[0].values.map(res => { return res.value })
                        let arr = this.state.pageList.filter(res => { return list.includes(res.value) })

                        let provinceStr = this.state.provinceStr || arr[0].value
                        if (this.state.pua && this.state.pua.length > 0) {
                            let info = arr.find(res => { return res.name === this.state.pua[0] })
                            provinceStr = info && info.value ? info.value : provinceStr
                        }
                        this.setState({
                            provinceList: arr,
                            provinceStr: provinceStr,
                            timeDate: new Date().getTime()
                        })
                    }
                    if (type === 'D111001') {
                        if (this.state.defaultValue && this.state.defaultValue.length === 3) {
                            let info = data.results[0].values.find(res => { return res.value === this.state.defaultValue[0] }) || ''
                            let info2 = info.subdimension.values.find(res => { return res.value === this.state.defaultValue[1] }) || ''
                            // if(['500000', '110000', '120000', '310000'].includes(info.value)){
                            //     info2 = info
                            // }else{
                            //     info2 = info.subdimension.values.find(res=>{return res.value === this.state.defaultValue[1]}) || ''
                            // }
                            let info3 = info2.subdimension.values.find(res => { return res.value === this.state.defaultValue[2] }) || ''
                            this.setState({
                                pageList: data.results[0].values,
                                pua: [info.name, info2.name, info3.name],
                                provinceStr: info.value,
                                cityStr: info2.value,
                                districtStr: info3.value
                            })
                            if (this.props.onClickCity) this.props.onClickCity(`${info.name},${info2.name},${info3.name}`, `${info.value},${info2.value},${info3.value}`);
                            if (info && info2 && info3) {
                                localStorage.setItem('ProvincialUrbanAreas', `${info.name},${info2.name},${info3.name}`)
                                localStorage.setItem('defaultValue', `${info.value},${info2.value},${info3.value}`)
                            }
                        } else {
                            this.setState({
                                pageList: data.results[0].values,
                                pua: [],
                                provinceStr: '',
                                cityStr: '',
                                districtStr: ''
                            })
                        }
                        this.queryPartCity()
                        // this.queryProvince("D330")
                        return
                    }
                    if (filter === 'D111001') {
                        let cityStr = this.state.cityStr || data.results[0].values[0].value
                        if (this.state.pua && this.state.pua.length > 1) {
                            let info = data.results[0].values.find(res => { return res.name === this.state.pua[1] })
                            cityStr = info && info.value ? info.value : cityStr
                        }
                        this.setState({
                            cityList: data.results[0].values,
                            cityStr: cityStr,
                            timeDate: new Date().getTime()
                        })
                    }
                    if (filter === 'D111002') {
                        let districtStr = this.state.districtStr || data.results[0].values[0].value
                        if (this.state.pua && this.state.pua.length > 2) {
                            let info = data.results[0].values.find(res => { return res.name === this.state.pua[2] })
                            districtStr = info && info.value ? info.value : districtStr
                        }
                        this.setState({
                            districtList: data.results[0].values,
                            districtStr: districtStr,
                            timeDate: new Date().getTime()
                        })
                    }
                    if (!this.state.cityList.length) {
                        this.queryProvince('D111002', 'D111001', this.state.provinceStr)
                    }
                    // if (!this.state.districtList.length && this.state.cityList.length && !['500000', '110000', '120000', '310000'].includes(this.state.provinceStr)) {
                    //     this.queryProvince('D111003', 'D111002', this.state.cityStr)
                    // }
                    if (!this.state.districtList.length && this.state.cityList.length) {
                        this.queryProvince('D111003', 'D111002', this.state.cityStr)
                    }
                }
            }
        }, this);
    }
    choiceCity(res) {
        let { choiceIndex, provinceStr, cityStr, districtStr } = this.state;
        // if(localStorage.getItem('ProvincialUrbanAreas') !== localStorage.getItem('ProvincialUrbanAreas')){
        //     localStorage.removeItem('ProvincialUrbanAreas')
        // }
        if (choiceIndex === 1) {
            if(res && res.link) return window.open(res.link)
            if (res.state == 0) {
                Toast.show({
                    content: '当前地区未开启申报窗口！',
                    maskClickable: false,
                })
                return
            }
            provinceStr = res.value
            res.subdimension.values.forEach(da => {
                da.label = da.name
            })
            this.setState({
                cityList: res.subdimension.values
            })
            // this.queryProvince('D111002', 'D111001', res.value)
        }
        // && !['500000', '110000', '120000', '310000'].includes(provinceStr)
        if (choiceIndex === 2) {
            cityStr = res.value
            res.subdimension.values.forEach(da => {
                da.label = da.name
            })
            this.setState({
                districtList: res.subdimension.values
            })
            // this.queryProvince('D111003', 'D111002', res.value)
        }
        // if (['500000', '110000', '120000', '310000'].includes(provinceStr)) {
        //     cityStr = provinceStr
        //     choiceIndex = choiceIndex === 1 ? 3 : choiceIndex
        // }
        this.setState({
            choiceIndex: choiceIndex === 1 || choiceIndex === 2 ? choiceIndex + 1 : choiceIndex,
            provinceStr: choiceIndex === 1 ? res.value : provinceStr,
            cityStr: choiceIndex === 2 ? res.value : cityStr,
            districtStr: choiceIndex === 3 ? res.value : districtStr,
        })
    }
    goUp() {
        const { choiceIndex, provinceStr } = this.state;
        if (!localStorage.getItem('ProvincialUrbanAreas')) {
            // if(['500000', '110000', '120000', '310000'].includes(provinceStr)){
            //     this.setState({
            //         choiceIndex: 1,
            //     })
            // }else{
            //     this.setState({
            //         choiceIndex: choiceIndex - 1,
            //     })
            // }
            this.setState({
                choiceIndex: choiceIndex - 1,
            })
        } else {
            const { pua } = this.state;
            let pop = delete pua[pua.length - 1]
            this.setState({
                pua: pop,
                // choiceIndex: ['500000', '110000', '120000', '310000'].includes(provinceStr)?1:choiceIndex - 1,
                choiceIndex: choiceIndex - 1,
            })
        }
    }
    goDown() {
        let { choiceIndex, provinceList, cityList, districtList } = this.state;
        console.log(choiceIndex, provinceList, cityList, districtList, 'choiceIndex, provinceList, cityList, districtList');
        if (choiceIndex === 3) {
            // if (['500000', '110000', '120000', '310000'].includes(this.state.provinceStr)) {
            //     districtList = cityList
            //     cityList = provinceList
            // }
            let provinceStr = provinceList.find(res => { return res.value === this.state.provinceStr })

            let cityStr = cityList.find(res => { return res.value === this.state.cityStr })
            let districtStr = districtList.find(res => { return res.value === this.state.districtStr })
            localStorage.setItem('ProvincialUrbanAreas', `${provinceStr?.label},${cityStr?.label},${districtStr?.label}`)
            localStorage.setItem('defaultValue', `${provinceStr?.value},${cityStr?.value},${districtStr?.value}`)
            this.setState({
                // choiceIndex: 1,
                showPop: false
            })
            if (this.props.onClickCity) this.props.onClickCity(`${provinceStr.label},${cityStr.label},${districtStr.label}`, `${provinceStr.value},${cityStr.value},${districtStr.value}`);
        } else {
            // this.setState({
            //     choiceIndex: choiceIndex+1,
            // }) 
        }
    }
    LayerBtn() {
        const { showPop } = this.state;
        this.setState({
            showPop: !showPop
        })
    }
    render() {
        let { pua, showPop, provinceStr, cityStr, districtStr, choiceIndex, provinceList, cityList, districtList, timeDate, defaultValue } = this.state;
        let showList = []
        if (choiceIndex === 1) {
            showList = provinceList
        } else if (choiceIndex === 2) {
            showList = cityList
        } else {
            // if (['500000', '110000', '120000', '310000'].includes(provinceStr)) {
            //     districtList = cityList
            //     cityList = provinceList
            //     showList = districtList
            // } else {
            //     showList = districtList
            // }
            showList = districtList
        }
        return <div className="sg-popup-all" key={timeDate}>
            <Popup visible={showPop} bodyStyle={{ height: 'auto' }}>
                <div className="sg-popup-view">
                    <div className="sg-view-top sd-middle">
                        <div className="sg-top-font">请选择申报地区</div>
                        <div className="sg-top-right" onClick={() => { this.LayerBtn() }}>
                            <CloseCircleOutline fontSize={'0.5rem'} color={'rgba(5,76,148,0.3)'} />
                        </div>
                    </div>

                    <div className="sg-view-center">
                        <div className="sg-center-top sd-start">
                            <DownFill fontSize={14} color={'#064B96'} style={{ transform: 'rotate(-90deg)', marginRight: '10px' }} />
                            <div className="sg-center-font">全国</div>
                            <RightOutline color={'#064B96'} fontSize={16} style={{ margin: '0 0.2rem', fontWeight: 600, display: provinceStr || pua[0] ? 'block' : 'none' }} />
                            <div className="sg-center-font">{
                                localStorage.getItem('ProvincialUrbanAreas') ?
                                    provinceStr && choiceIndex > 0 && provinceList.length > 0 && provinceList.find(res => { return res.value === provinceStr }).label ?
                                        provinceStr && choiceIndex > 0 && provinceList.length > 0 && provinceList.find(res => { return res.value === provinceStr }).label :
                                        pua[0] :
                                    provinceStr && choiceIndex > 0 && provinceList.length > 0 && provinceList.find(res => { return res.value === provinceStr }).label
                            }</div>

                            <RightOutline color={'#064B96'} fontSize={16} style={{ margin: '0 0.2rem', fontWeight: 600, display: cityStr && choiceIndex > 1 ? 'block' : 'none' }} />
                            <div className="sg-center-font" >{
                                localStorage.getItem('ProvincialUrbanAreas') ? cityStr && choiceIndex > 1 && cityList.length > 0 && cityList.find(res => { return res.value === cityStr }) && cityList.find(res => { return res.value === cityStr }).label ? cityStr && choiceIndex > 1 && cityList.length > 0 && cityList.find(res => { return res.value === cityStr }) && cityList.find(res => { return res.value === cityStr }).label : pua[1] :
                                    cityStr && choiceIndex > 1 && cityList.length > 0 && cityList.find(res => { return res.value === cityStr }) && cityList.find(res => { return res.value === cityStr }).label
                            }</div>
                            <RightOutline color={'#064B96'} fontSize={16} style={{ margin: '0 0.2rem', fontWeight: 600, display: districtStr && choiceIndex > 2 ? 'block' : 'none' }} />
                            <div className="sg-center-font">{
                                localStorage.getItem('ProvincialUrbanAreas') ? districtStr && choiceIndex > 2 && districtList.length > 0 && districtList.find(res => { return res.value === districtStr }) && districtList.find(res => { return res.value === districtStr }).label ? districtStr && choiceIndex > 2 && districtList.length > 0 && districtList.find(res => { return res.value === districtStr }) && districtList.find(res => { return res.value === districtStr }).label : pua[2] :
                                    districtStr && choiceIndex > 2 && districtList.length > 0 && districtList.find(res => { return res.value === districtStr }) && districtList.find(res => { return res.value === districtStr }).label
                            }</div>
                        </div>
                        <div className="sg-center-view sd-spaceBetween sd-wrap">
                            {
                                showList.map(res => {
                                    {
                                        if (choiceIndex == 1) {
                                            return <div onClick={() => { this.choiceCity(res) }} className={`sg-view-list sd-middle ${res.state == 0 ? 'sg-view-aaa' : ''} ${provinceStr === res.value || cityStr === res.value || districtStr === res.value ? 'sg-choice-list' : ''}`}><div className="sd-fontHidden">{res.label}</div></div>
                                        } else {
                                            return <div style={{ display: res.ISOPEN === 'N' ? 'none' : '' }} onClick={res.ISOPEN === 'N' ? {} : () => { this.choiceCity(res) }} className={`sg-view-list sd-middle ${res.ISOPEN === 'N' ? 'sg-view-aaa' : ''} ${provinceStr === res.value || cityStr === res.value || districtStr === res.value ? 'sg-choice-list' : ''}`}><div className="sd-fontHidden">{res.label}</div></div>
                                        }
                                    }
                                })
                            }

                            <div className="sg-view-listLayer"></div>
                            <div className="sg-view-listLayer"></div>
                        </div>
                        <div className="sg-center-bototm">
                            <div className="sg-bottom-top sd-middle" style={{ display: choiceIndex > 1 ? 'flex' : 'none' }}>
                                <div className="sg-top-list sd-middle sg-list-bg1" onClick={() => { this.goUp() }}>返回上一级</div>
                                <div className="sg-top-list sd-middle" style={{ display: choiceIndex > 2 && showList.some(item => item.value.includes(districtStr)) ? 'flex' : 'none' }} onClick={() => { this.goDown() }}>确认</div>
                            </div>
                            <div className="sg-bototm-tips sd-middle">仅显示和可进入开启申报的地区</div>
                        </div>
                    </div>
                </div>
            </Popup>
        </div>
    }
}

export default WidgetPopup;